import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { observePublicTestIds } from '../utils/publicTestIds';
import '@fontsource/dm-sans/latin-400.css';
import '@fontsource/dm-sans/latin-500.css';
import '@fontsource/dm-sans/latin-600.css';
import '@fontsource/libre-caslon-display/latin-400.css';
import '../styles/public-design.css';
import '../styles/public-components.css';
import '../styles/home-v2.css';

// Body scope also includes Radix dropdowns/dialogs rendered through portals.
// Route cleanup prevents any public styling from leaking into administration.
export const PublicDesign = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const enabled = !/^\/(admin|content-preview|design-vergleich)(\/|$)/.test(pathname);
    document.body.classList.toggle('ak-public', enabled);
    const disconnect = enabled ? observePublicTestIds(pathname) : () => {};
    return () => { disconnect(); document.body.classList.remove('ak-public'); };
  }, [pathname]);
  return null;
};